import Blank from "@/layouts/blank.vue"

import UserManagementList from "@/pages/customer/user-management/UsersList.vue";
import UserManagementAdd from "@/pages/customer/user-management/UserAdd.vue";
import UserManagementEdit from "@/pages/customer/user-management/UserEdit.vue";

const userManagementRoutes = [
  {
    path: "user-management",
    name: "app-customer-user-management",
    component: Blank,
    children: [
      {
        path: "/",
        redirect: "/app/customer/user-management/list",
      },
      {
        path: "list",
        name: "app-customer-user-management-list",
        component: UserManagementList,
      },
      {
        path: "add",
        name: "app-customer-user-management-add",
        component: UserManagementAdd,
      },
      {
        path: "edit",
        name: "app-customer-user-management-edit",
        component: Blank,
        children: [
          {
            path: "/",
            redirect: "/app/customer/user-management/list",
          },
          {
            path: ":id",
            name: "app-customer-user-management-edit-id",
            component: UserManagementEdit,
          }
        ]
      },
    ]
  },
]

export default userManagementRoutes